import React from 'react';
import Slider from 'react-slick';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'slick-carousel/slick/slick.css'; // Import Slick carousel styles
import 'slick-carousel/slick/slick-theme.css'; // Import Slick carousel theme styles

const Brand = ({ brands = [] }) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const sample = [
    "images/Engineering/eng-brand1.png",
    "images/Engineering/eng-brand2.png",
    "images/Engineering/eng-brand3.png",
    "images/Engineering/eng-brand4.png",
    "/images/Aecom.png",
    "images/Engineering/eng-brand5.jpg",
  ];

  const list = brands.length ? brands : sample;


  return (
    <div className="container   "  >
      <div className="col-lg-6 offset-lg-3">
        <h2 className="text-center Layout-Title">TOP BRANDS</h2>
        <p className="text-center mb-5">
          {/* From its medieval origins to the digital era, learn everything there is
          to know about the ubiquitous lorem ipsum passage. */}
          For those who prefer to shop directly from a trusted manufacturer, our brand catalogue is the perfect starting point.
        </p>
      </div>

      <div className="row no-gutters mt-3">
        <div className="col-md-12 div-anim my-auto">
          <div className="brand-carousel-wrapper" style={{ width: "60%", alignContent: "center", margin: "auto" }}>
            <Slider {...settings} className="no-gap-slider">
              {list.map((b, idx) => (
                <div className="no-gap-slide-wrap" key={idx}>
                  <div className="no-gap-slide">
                    <img
                      src={typeof b === "string" ? b : b.images?.[0] || "/images/default.png"}
                      alt={typeof b === "string" ? `brand-${idx}` : b.name}
                      className="no-gap-img"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-center align-items-center'>
        <div class="row mt-5 gutter-5" style={{ padding: "20px" }}>
          <div class="col-lg-3">
            <div class="feature-outer">
              <img src="images/feature1.png" class="feature-img img-fluid" />
              <a href="#">
                <h5>Premium LED Headlights</h5>
              </a>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="feature-outer">
              <img src="images/feature2.png" class="feature-img img-fluid" />
              <a href="#">
                <h5>Premium qulaity steering</h5>
              </a>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="feature-outer">
              <img src="images/feature3.png" class="feature-img img-fluid" />
              <a href="#">
                <h5>Premium Tyres </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brand;
